import useFormFields from './useFormFields'
import useSubmitBtns from './useSubmitBtns'
import useAlert from './useAlert'
import useCleanData from './useCleanData'

export default { useFormFields, useSubmitBtns, useAlert, useCleanData }